<template>
  <base-dialog
  ref="base"
  v-model="$imagePreviewDialog.model"
  width="600"
  :title="$t($t('dialogs.titles.imagePreview', {'value': $imagePreviewDialog.title}))"
  header-bg="darkBlue"
  :loading="loading">
    <!-- zoomist-container -->
    <div
    class="zoomist-container">
      <!-- zoomist-wrapper is required -->
      <div class="zoomist-wrapper">
        <!-- zoomist-image is required -->
        <div class="zoomist-image">
          <img
          :src="$imagePreviewDialog.value"
          @load="onImageReady"
          width="100%"
          style="object-fit: contain;"/>
        </div>
      </div>
    </div>
    
    <v-row>
      <v-col class="d-flex justify-center align-center px-4 py-6">
        <outlined-btn
        :label="$t('btns.close')"
        color="#0d47a1"
        :width="100"
        :height="45"
        @click="closeDialog"/>
      </v-col>
    </v-row>
  </base-dialog>
</template>
<script>
import BaseDialog from '@/components/dialogs/BaseDialog'
import OutlinedBtn from '@/components/btns/OutlinedBtn'
import 'zoomist/css'
import Zoomist from 'zoomist'
export default {
  components: {
    OutlinedBtn,
    BaseDialog
  },
  data() {
    return {
      zoomist: null,
      loading: true,
    }
  },
  computed: {
    
  },
  methods: {
    closeDialog() {
      this.$imagePreviewDialog.model = false
    },
    onImageReady() {
      this.loading = false
      this.initZoomist()
    },
    initZoomist() {
      this.zoomist = new Zoomist(".zoomist-container", {
        draggable: true,
        wheelable: true,
        pinchable: true,
        slider: false,
        zoomer: true
      })
    }
  }
}
</script>
<style>
</style>
